var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuracao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.406 -26.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.743,70.544H28.437a.36.36,0,0,1-.347-.371V56.915a.36.36,0,0,1,.347-.371H47.743a.36.36,0,0,1,.347.371V70.173A.36.36,0,0,1,47.743,70.544Z",
    transform: "translate(-26.684 -29.91)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1.802,
    transform: "translate(1.406 36.244)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.79 28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.379,132.911l-.355,1.063-1.121.009a.112.112,0,0,0-.066.2l.9.666-.338,1.068a.112.112,0,0,0,.172.125l.912-.652.912.652a.112.112,0,0,0,.172-.125l-.338-1.068.9-.666a.112.112,0,0,0-.066-.2l-1.121-.009-.355-1.063A.112.112,0,0,0,105.379,132.911Z",
    transform: "translate(-101.906 -130.905)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.055,88.218l-.205.615-.649.005a.065.065,0,0,0-.038.117l.522.385-.2.618a.065.065,0,0,0,.1.072l.528-.377.528.377a.065.065,0,0,0,.1-.072l-.2-.618.522-.385a.065.065,0,0,0-.038-.117l-.649-.005-.205-.615A.065.065,0,0,0,61.055,88.218Z",
    transform: "translate(-60.137 -88.174)",
    fill: "#f5f5f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuracao);
export default __webpack_public_path__ + "static/media/curacao.35aa4bc0e44eba5b08383135abb4f830.svg";
export { ForwardRef as ReactComponent };